export var GraphType;
(function (GraphType) {
    GraphType[GraphType["SVG"] = 0] = "SVG";
    GraphType[GraphType["Image"] = 1] = "Image";
})(GraphType || (GraphType = {}));
